/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import DecisionIcon from '@atlaskit/icon/core/migration/decision--editor-decision';
import Item from './Item';
var iconStyles = function iconStyles(showPlaceholder) {
  return css({
    flex: '0 0 16px',
    height: '16px',
    width: '16px',
    margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-150, 12px)", " 0 0"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: showPlaceholder ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-success, #22A06B)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });
};
var DecisionItem = function DecisionItem(_ref) {
  var appearance = _ref.appearance,
    children = _ref.children,
    contentRef = _ref.contentRef,
    placeholder = _ref.placeholder,
    showPlaceholder = _ref.showPlaceholder,
    dataAttributes = _ref.dataAttributes;
  var icon =
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
  jsx("span", {
    contentEditable: false,
    css: iconStyles(showPlaceholder)
  }, jsx(DecisionIcon, {
    label: "Decision",
    spacing: "spacious",
    color: "currentColor",
    LEGACY_size: "large"
  }));
  return jsx(Item, {
    appearance: appearance,
    contentRef: contentRef,
    icon: icon,
    placeholder: placeholder,
    showPlaceholder: showPlaceholder,
    itemType: "DECISION",
    dataAttributes: dataAttributes
  }, children);
};
export default DecisionItem;